import { Divider, MenuItem } from '@hive/component';
import { GlobalDialogService } from '@hive/core/modules/dialogs';
import { FeatureFlagService } from '@hive/core/modules/feature-flag';
import { useI18n } from '@hive/i18n';
import { PlusIcon } from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';
import { useCallback } from 'react';

import {
  ItemContainer,
  ItemText,
  prefixIcon,
} from '../add-workspace/index.css';
import { addServerDividerWrapper } from './index.css';

export const AddServer = () => {
  const t = useI18n();
  const globalDialogService = useService(GlobalDialogService);
  const featureFlagService = useService(FeatureFlagService);
  const enableMultipleServer = useLiveData(
    featureFlagService.flags.enable_multiple_cloud_servers.$
  );

  const onAddServer = useCallback(() => {
    globalDialogService.open('sign-in', { step: 'addSelfhosted' });
  }, [globalDialogService]);

  if (!enableMultipleServer) {
    return null;
  }
  return (
    <>
      <div className={addServerDividerWrapper}>
        <Divider size="thinner" />
      </div>
      <MenuItem
        block={true}
        prefixIcon={<PlusIcon />}
        prefixIconClassName={prefixIcon}
        onClick={onAddServer}
        data-testid="new-server"
        className={ItemContainer}
      >
        <div className={ItemText}>
          {t['com.hive.workspaceList.addServer']()}
        </div>
      </MenuItem>
    </>
  );
};
